import type { TranslationMessages } from '../types';

export const navigation_groups: TranslationMessages = {
  products: 'Products',
  sales_orders: 'Sales & Orders',
  inventory: 'Inventory',
  staff: 'Staff',
  marketing: 'Marketing',
  costs: 'Costs',
  recipes_ingredients: 'Recipes & Ingredients',
  project_management: 'Project Management',
  settings: 'Settings',
  };
